export default __webpack_public_path__ + "static/media/team4.90442559.png";